import { Outlet } from 'react-router-dom';

import { SystemLinks } from 'applications/GSP/entities/SystemLinks';
import { useIsAdminView } from 'applications/GSP/shared/hooks/user';
import { useMediaQuery } from 'shared/hooks/dom';

import { AdminViewFooter } from './components/AdminViewFooter';
import { AdminViewFooterWrapperDesktop } from './components/AdminViewFooterWrapperDesktop';
import { Content } from './components/Content';
import { FooterWrapper } from './components/FooterWrapper';
import { Header } from './components/Header';
import { MainContentWrapper } from './components/MainContentWrapper';
import { MainLayoutWrapper } from './components/MainLayoutWrapper';
import { MainLoader } from './components/MainLoader';
import { Sidebar } from './components/Sidebar';
import { useAnalyticsMasqueradingSessionDuration } from './hooks';

import type { FC } from 'react';

export const MAIN_LAYOUT_TEST_ID = 'main-layout';

export const MainLayout: FC = () => {
  const matches = useMediaQuery('md');
  const isAdminView = useIsAdminView();

  useAnalyticsMasqueradingSessionDuration();

  return (
    <>
      <MainLayoutWrapper data-testid={MAIN_LAYOUT_TEST_ID}>
        <Sidebar />
        <MainContentWrapper>
          <Header />
          <Content>
            <Outlet />
          </Content>
          {!matches && isAdminView && <AdminViewFooter />}
          {matches && (
            <FooterWrapper>
              <SystemLinks />
            </FooterWrapper>
          )}
        </MainContentWrapper>
      </MainLayoutWrapper>
      {matches && isAdminView && (
        <AdminViewFooterWrapperDesktop>
          <AdminViewFooter />
        </AdminViewFooterWrapperDesktop>
      )}
      <MainLoader />
    </>
  );
};
